(function () {
  document.querySelectorAll('.byo-product').forEach(function (root) {
    var sectionIdRaw = root.getAttribute('data-section-id');
    if (!sectionIdRaw) return; // FIX: this element has no data-section-id (e.g. the
    // "Product Description" section block) — bail out instead of crashing on
    // sectionIdRaw.replace(...) below. This was aborting the forEach loop and
    // silently killing setup for every element after this one.

    var dataKey = 'byoProductData_' + sectionIdRaw.replace(/-/g, '');
    var data = window[dataKey];
    if (!data) return;

    var variants = data.variants;
    var selected = {}; // optionIndex -> value

    // seed `selected` from currently-active buttons
    root.querySelectorAll('.byo-swatch.active, .byo-pill.active').forEach(function (btn) {
      selected[btn.getAttribute('data-option-index')] = btn.getAttribute('data-value');
    });

    function findVariant() {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return Object.keys(selected).every(function (idx) {
          return opts[idx] === selected[idx];
        });
      });
    }

    // --- Gallery: switch main media panel + active thumb, given a media id ---
    function activateMedia(mediaId) {
      if (!mediaId) return;
      var panels = root.querySelectorAll('.byo-media-panel');
      var thumbs = root.querySelectorAll('.byo-thumb');
      var found = false;

      panels.forEach(function (panel) {
        var isTarget = panel.getAttribute('data-media-id') === String(mediaId);
        panel.classList.toggle('active', isTarget);
        if (isTarget) found = true;

        if (!isTarget) {
          var video = panel.querySelector('video');
          if (video && !video.paused) video.pause();
          var iframe = panel.querySelector('iframe');
          if (iframe) iframe.src = iframe.src; // stop external video playback
        }
      });

      thumbs.forEach(function (t) {
        t.classList.toggle('active', t.getAttribute('data-media-id') === String(mediaId));
      });

      return found;
    }

    // FIX: added thousands-separator support so a price updated via JS after a
    // variant change matches the comma-formatted price Liquid's `money` filter
    // renders on first page load (e.g. "Rs.1,999.00" instead of "Rs.1999.00").
    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      amount = parts.join('.');
      return (data.moneyFormat || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    function updateUI(variant) {
      if (!variant) return;
      var idInput = root.querySelector('#byo-variant-id');
      if (idInput) idInput.value = variant.id;

      var now = root.querySelector('#byo-price-now');
      var old = root.querySelector('#byo-price-old');
      var off = root.querySelector('#byo-price-off');
      if (now) now.textContent = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (old) { old.textContent = formatMoney(variant.compare_at_price); old.hidden = false; }
        if (off) {
          var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          off.textContent = 'Save ' + pct + '%';
          off.hidden = false;
        }
      } else {
        if (old) old.hidden = true;
        if (off) off.hidden = true;
      }

      var addBtn = root.querySelector('#byo-add-cart');
      var buyBtn = root.querySelector('#byo-buy-now');
      var stickyAddBtn = root.querySelector('#byo-sticky-add-cart');
      var stickyBuyBtn = root.querySelector('#byo-sticky-buy-now');
      [addBtn, buyBtn, stickyAddBtn, stickyBuyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !variant.available;
      });
      if (addBtn) addBtn.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      if (stickyAddBtn) stickyAddBtn.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';

      var stockLine = root.querySelector('#byo-stock-line');
      var stockText = root.querySelector('#byo-stock-text');
      var stockFill = root.querySelector('#byo-stock-fill');
      var threshold = data.lowStockThreshold || 10;
      if (stockLine) {
        if (variant.inventory_management === 'shopify' && variant.inventory_quantity <= threshold && variant.inventory_quantity > 0) {
          stockLine.hidden = false;
          if (stockText) {
            var prefix = stockLine.getAttribute('data-stock-prefix') || '';
            var suffix = stockLine.getAttribute('data-stock-suffix') || '';
            stockText.textContent = prefix + variant.inventory_quantity + suffix;
          }
          if (stockFill) stockFill.style.width = Math.min(100, (variant.inventory_quantity / threshold) * 100) + '%';
        } else {
          stockLine.hidden = true;
        }
      }

      // Switch gallery to this variant's media (image or video), if it has one
      if (variant.featured_media && variant.featured_media.id) {
        activateMedia(variant.featured_media.id);
      }
    }

    // Option button clicks
    root.querySelectorAll('.byo-swatch, .byo-pill').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-option-index');
        var value = btn.getAttribute('data-value');
        selected[idx] = value;

        var block = btn.closest('.byo-option-block');
        block.querySelectorAll('.byo-swatch, .byo-pill').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var label = block.querySelector('.byo-option-selected');
        if (label) label.textContent = value;

        updateUI(findVariant());
      });
    });

    // Thumbnail gallery — switches main panel (image, video, external video, or model)
    root.querySelectorAll('.byo-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateMedia(thumb.getAttribute('data-media-id'));
      });
    });

    // Video tag pills ("Product Video" / "How To Use" / "Use Case") -> popup modal
    var videoModal = root.querySelector('[data-byo-video-modal]');
    if (videoModal) {
      var videoPanels = videoModal.querySelectorAll('.byo-video-modal__panel');

      var openVideoModal = function (key) {
        videoPanels.forEach(function (panel) {
          var match = panel.getAttribute('data-video-panel') === key;
          panel.classList.toggle('active', match);
          if (match) {
            var v = panel.querySelector('video');
            if (v) {
              v.currentTime = 0;
              v.play().catch(function () {});
            }
          }
        });
        videoModal.classList.add('is-open');
        videoModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      };

      var closeVideoModal = function () {
        videoModal.classList.remove('is-open');
        videoModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        videoModal.querySelectorAll('video').forEach(function (v) { v.pause(); });
      };

      root.querySelectorAll('.byo-video-tag').forEach(function (btn) {
        btn.addEventListener('click', function () {
          openVideoModal(btn.getAttribute('data-video-target'));
        });
      });

      videoModal.querySelectorAll('[data-byo-video-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeVideoModal);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && videoModal.classList.contains('is-open')) closeVideoModal();
      });
    }

    // Quantity stepper
    var qtyVal = root.querySelector('#byo-qty-val');
    var minus = root.querySelector('#byo-qty-minus');
    var plus = root.querySelector('#byo-qty-plus');
    if (qtyVal && minus && plus) {
      minus.addEventListener('click', function () {
        qtyVal.value = Math.max(1, (parseInt(qtyVal.value, 10) || 1) - 1);
      });
      plus.addEventListener('click', function () {
        qtyVal.value = (parseInt(qtyVal.value, 10) || 1) + 1;
      });
    }

    // Add to Cart / Buy Now — both AJAX now, no full page reload for either.
    var buyNowBtn = root.querySelector('#byo-buy-now');
    var addCartBtn = root.querySelector('#byo-add-cart');
    var form = root.querySelector('#byo-product-form');

    function showToast(message) {
      var toast = document.querySelector('[data-byo-toast]');
      if (!toast) {
        toast = document.createElement('div');
        toast.setAttribute('data-byo-toast', '');
        toast.className = 'byo-toast';
        document.body.appendChild(toast);
      }
      toast.textContent = message;
      toast.classList.add('is-visible');
      clearTimeout(toast._hideTimer);
      toast._hideTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2200);
    }

    function syncHeaderCartCount(cart) {
      var count = cart.item_count;
      var countText = count > 0 ? String(count) : '';
      document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
        el.textContent = countText;
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        // Buy Now has its own click handler below with its own preventDefault,
        // so a submit triggered by that button never reaches here. This only
        // ever runs for the regular Add to Cart button.
        if (addCartBtn.disabled) { e.preventDefault(); return; }

        var cartIconEl = document.querySelector('cart-icon.header-actions__cart-icon');
        var cartWasEmpty = cartIconEl ? !cartIconEl.classList.contains('header-actions__cart-icon--has-cart') : false;

        // Cart is empty: skip AJAX entirely and let this be a real, native form
        // submission straight to the cart page. This is a single browser
        // navigation (fetch-then-redirect would be two sequential round trips,
        // which is the extra delay this replaces).
        if (cartWasEmpty) {
          var returnToInput = form.querySelector('input[name="return_to"]');
          if (!returnToInput) {
            returnToInput = document.createElement('input');
            returnToInput.type = 'hidden';
            returnToInput.name = 'return_to';
            form.appendChild(returnToInput);
          }
          returnToInput.value = data.cartUrl || '/cart';
          addCartBtn.disabled = true;
          addCartBtn.textContent = 'Adding…';
          return; // let the browser submit natively — no preventDefault here
        }

        e.preventDefault();
        var originalLabel = addCartBtn.textContent;

        addCartBtn.disabled = true;
        addCartBtn.textContent = 'Adding…';

        var formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            addCartBtn.textContent = 'Added ✓';
            showToast('✓ Added to cart');
            return fetch('/cart.js');
          })
          .then(function (res) { return res && res.json(); })
          .then(function (cart) {
            if (cart) syncHeaderCartCount(cart);
          })
          .catch(function () {
            form.submit(); // reliable fallback if the AJAX path fails for any reason
          })
          .finally(function () {
            setTimeout(function () {
              addCartBtn.disabled = false;
              addCartBtn.textContent = originalLabel;
            }, 1000);
          });
      });
    }

    if (buyNowBtn && form) {
      buyNowBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () { form.submit(); });
      });
    }

    // Sticky bottom bar — shows once the main buy row scrolls out of view.
    // Its buttons just forward clicks to the real buttons above, so all
    // existing add-to-cart / buy-now logic (and disabled/label state) stays
    // in one place and never gets out of sync.
    var stickyBar = root.querySelector('[data-byo-sticky-bar]');
    var buyRow = form;
    if (stickyBar && buyRow && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var showSticky = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            stickyBar.classList.toggle('is-visible', showSticky);
            stickyBar.setAttribute('aria-hidden', showSticky ? 'false' : 'true');
          });
        },
        { threshold: 0 }
      );
      stickyObserver.observe(buyRow);
    }

    var stickyAddCartBtn = root.querySelector('#byo-sticky-add-cart');
    var stickyBuyNowBtn = root.querySelector('#byo-sticky-buy-now');
    if (stickyAddCartBtn && addCartBtn) {
      stickyAddCartBtn.addEventListener('click', function () {
        if (!addCartBtn.disabled) addCartBtn.click();
      });
    }
    if (stickyBuyNowBtn && buyNowBtn) {
      stickyBuyNowBtn.addEventListener('click', function () {
        if (!buyNowBtn.disabled) buyNowBtn.click();
      });
    }

    // Tabs
    var tabHeads = root.querySelectorAll('.byo-tab-head');
    var tabPanels = root.querySelectorAll('.byo-tab-panel');
    tabHeads.forEach(function (head) {
      head.addEventListener('click', function () {
        tabHeads.forEach(function (h) { h.classList.remove('active'); });
        tabPanels.forEach(function (p) { p.hidden = true; p.classList.remove('active'); });
        head.classList.add('active');
        var target = root.querySelector('.byo-tab-panel[data-panel="' + head.getAttribute('data-tab') + '"]');
        if (target) { target.hidden = false; target.classList.add('active'); }
      });
    });

    // Flash countdown
    var strip = root.querySelector('.byo-flash-strip');
    if (strip) {
      var end = new Date(strip.getAttribute('data-end')).getTime();
      var hEl = strip.querySelector('.byo-cd-h');
      var mEl = strip.querySelector('.byo-cd-m');
      var sEl = strip.querySelector('.byo-cd-s');

      function endFlashSale() {
        strip.classList.add('byo-flash-ended');
        var now = root.querySelector('#byo-price-now');
        var old = root.querySelector('#byo-price-old');
        var off = root.querySelector('#byo-price-off');
        var galleryBadge = root.querySelector('.byo-gallery-main .byo-badge');
        if (now && old && !old.hidden) { now.textContent = old.textContent; }
        if (old) old.hidden = true;
        if (off) off.hidden = true;
        if (galleryBadge) galleryBadge.style.display = 'none';
      }

      function tick() {
        var diff = end - Date.now();
        if (isNaN(end) || diff <= 0) { endFlashSale(); return; }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (hEl) hEl.textContent = String(h).padStart(2, '0');
        if (mEl) mEl.textContent = String(m).padStart(2, '0');
        if (sEl) sEl.textContent = String(s).padStart(2, '0');
      }
      tick();
      var flashInterval = setInterval(function () {
        tick();
        if (isNaN(end) || end - Date.now() <= 0) clearInterval(flashInterval);
      }, 1000);
    }
  });
})();